import {
  ASSIGN_SPECIALIST_LIST,
  ASSIGN_SPECIALIST_LIST_FAILURE,
  ASSIGN_SPECIALIST_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const assignSpecialistProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_SPECIALIST_LIST:
      return { ...state, loading: true };
    case ASSIGN_SPECIALIST_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ASSIGN_SPECIALIST_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default assignSpecialistProviderReducer;
